import { render, staticRenderFns } from "./AccountBreadcrumbRoute.vue?vue&type=template&id=c8643184&"
import script from "./AccountBreadcrumbRoute.vue?vue&type=script&lang=js&"
export * from "./AccountBreadcrumbRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports